/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";
import {
  setConfigurationTypeImplementation,
  setFullScreenImplementation,
  setIsNewSessionIdImplementation,
  setLocaleImplementation,
  setSavedConfigurationsImplementation,
  setSessionIdFetchedImplementation,
  setUpdatingConfigurationImplementation
} from "../implementations/commonImplementation";
import { EVENTS_DATA } from "../data/commonData";

const initialState = {
  locale: "en-WW",
  eventsData: EVENTS_DATA,
  fullScreen: false,
  configurationType: null,
  sessionIdFetched: false,
  isNewSessionId: false,
  savedConfigurations: [],
  updatingConfiguration: false,
  updateConfiguration: false,
  showCancelDialogPopup: false,
  technologiesScope: null,
  seamlessSessionIdFetched: false,
  seamlessSession: null
};

export const common = createSlice({
  name: "common",
  initialState,
  reducers: {
    setLocale: (state, action) => {
      setLocaleImplementation(state, action);
    },
    setFullScreen: (state, action) => {
      setFullScreenImplementation(state, action);
    },
    setConfigurationType: (state, action) => {
      setConfigurationTypeImplementation(state, action);
    },
    setSessionIdFetched: (state, action) => {
      setSessionIdFetchedImplementation(state, action);
    },
    setIsNewSessionId: (state, action) => {
      setIsNewSessionIdImplementation(state, action);
    },
    setSavedConfigurations: (state, action) => {
      setSavedConfigurationsImplementation(state, action);
    },
    setUpdatingConfiguration: (state, action) => {
      setUpdatingConfigurationImplementation(state, action);
    },
    updateConfiguration: (state) => {
      state.updateConfiguration = !state.updateConfiguration;
    },
    setShowCancelDialogPopup: (state, action) => {
      state.showCancelDialogPopup = action.payload;
    },
    setTechnologiesScope: (state, action) => {
      state.technologiesScope = action.payload;
    },
    setSeamlessSessionIdFetched: (state, action) => {
      state.seamlessSessionIdFetched = action.payload;
    },
    setSeamlessSession(state, action) {
      console.debug("ciam?", action);
      state.seamlessSession = {
        id: action.payload.custom_attributes.federatedId,
        name: action.payload.name,
        email: action.payload.email,
        isInternal: action.payload.custom_attributes.isInternal === "TRUE"
      };
      if (action.payload.custom_attributes) {
        const userChannels = {};
        userChannels.channel1 = action.payload.custom_attributes.classLevel1;
        userChannels.channel2 = action.payload.custom_attributes.classLevel2;
        state.seamlessSession.userChannels = userChannels;
      }
      console.debug("setSeamlessSession with ciam:", state.seamlessSession);
    },
    setSeamlessSessionWithOkta(state, action) {
      console.debug("okta?", action);
      state.seamlessSession = {
        id: action.payload.id,
        name: action.payload.name,
        email: action.payload.email,
        isInternal: action.payload.isInternal === "TRUE"
      };
      if (action.payload.userChannels) {
        const userChannels = {};
        userChannels.channel1 = action.payload.userChannels.classLevel1;
        userChannels.channel2 = action.payload.userChannels.classLevel2;
        state.seamlessSession.userChannels = userChannels;
      }
      console.debug("setSeamlessSessionWithOkta with okta:", state.seamlessSession);
    },
    resetCommon: (state) => {
      const resetState = {
        ...initialState,
        locale: state.locale,
        eventsData: state.eventsData,
        sessionIdFetched: state.sessionIdFetched,
        isNewSessionId: state.isNewSessionId,
        technologiesScope: state.technologiesScope,
        seamlessSessionIdFetched: state.seamlessSessionIdFetched,
        seamlessSession: state.seamlessSession
      };
      return resetState;
    }
  }
});

export const {
  setLocale,
  setFullScreen,
  setConfigurationType,
  setSessionIdFetched,
  setIsNewSessionId,
  setSavedConfigurations,
  setUpdatingConfiguration,
  resetCommon,
  updateConfiguration,
  setShowCancelDialogPopup,
  setTechnologiesScope,
  setSeamlessSessionIdFetched,
  setSeamlessSession,
  setSeamlessSessionWithOkta
} = common.actions;

export const selectLocale = (state) => state.common.locale;
export const selectEventsData = (state) => state.common.eventsData;
export const selectFullScreen = (state) => state.common.fullScreen;
export const selectConfigurationType = (state) => state.common.configurationType;
export const selectSessionIdFetched = (state) => state.common.sessionIdFetched;
export const selectIsNewSessionId = (state) => state.common.isNewSessionId;
export const selectSavedConfigurations = (state) => state.common.savedConfigurations;
export const selectUpdatingConfiguration = (state) => state.common.updatingConfiguration;
export const selectUpdateConfiguration = (state) => state.common.updateConfiguration;
export const selectShowCancelDialogPopup = (state) => state.common.showCancelDialogPopup;
export const selectTechnologiesScope = (state) => state.common.technologiesScope;
export const selectSeamlessSessionIdFetched = (state) => state.common.seamlessSessionIdFetched;
export const selectSeamlessSession = (state) => state.common.seamlessSession;

export default common.reducer;
